import * as React from 'react';

import _ from 'underscore';

import styles from './list-summaries-error-state.module.css';

const EMPTY_ROW_COUNT = 5;

export class ListSummariesErrorState extends React.Component {
    render() {
        const emptyRows = _.range(EMPTY_ROW_COUNT).map((column, index) => {
            return <div key={`empty-row-${index}`} className={styles['empty-row']} />;
        });

        return (
            <div className={styles.container}>
                {emptyRows}
                <div className={styles['error-image-container']}>
                    <img
                        src='/include/images/dashboard/list-summary-error_2x.png'
                        className={styles['error-image']}
                    />
                </div>
                <div className={styles['error-text']}>
                    <span>We couldn’t load these summaries right now</span>
                </div>
            </div>
        );
    }
}
